<template>
    <div class="container">
      <headers></headers>
      <right></right>
      <scrollpage></scrollpage>
      <word ref="word"></word>

      <div class="w box_sizing width_box my_wrap">
        <div class="left_position">
          <left></left>
        </div>
        <div v-if="pageLoading" class="score_loading_state">
          <div class="score_loading_spinner"><i class="el-icon-loading"></i></div>
          <div class="score_loading_title">结果加载中</div>
          <div class="score_loading_text">正在整理本次模考结果，请稍后查看。</div>
        </div>
        <template v-else>
        <!-- 用户信息和分享区域 -->
        <div class="user_info_card" v-if="userInfo">
          <div class="user_info_left">
            <img class="user_avatar" :src="userInfo.avatar || require('@/assets/images/touxiang.png')" alt="用户头像" />
            <div class="user_detail">
              <div class="user_name">{{ userInfo.nickname || userInfo.username || '匿名用户' }}</div>
              <div class="exam_info">
                <span class="exam_title">{{ examTitle }}</span>
                <span class="exam_time">答题时间：{{ examCreatetime }}</span>
              </div>
            </div>
          </div>
          <div class="user_info_right">
            <el-button type="primary" size="small" @click="shareExam" icon="el-icon-share">分享试卷</el-button>
          </div>
        </div>
        <div class="skills_profile_card" v-if="skillsProfileRows.length">
          <div class="skills_profile_header">
            <div>
              <div class="skills_profile_heading">PTE小分分析</div>
              <div class="skills_profile_caption">Your Skills Profile</div>
            </div>
          </div>
          <div class="skills_profile_list">
            <div class="skills_profile_item" v-for="item in skillsProfileRows" :key="item.key">
              <div class="skills_profile_item_top">
                <div class="skills_profile_meta">
                  <div class="skills_profile_name">{{ item.label }}</div>
                  <!-- <div class="skills_profile_name_cn">{{ item.cnLabel }}</div> -->
                  <div class="skills_profile_alias">{{ item.aliasText }}</div>
                </div>
              </div>
              <div class="skills_profile_bar">
                <div class="skills_profile_bar_fill" :style="{ width: profileBarWidth(item.score, item.key) }"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="score_pending_notice" v-if="scorePending">
          <div class="score_pending_title">分数计算中，请稍后</div>
          <div class="score_pending_text">系统正在计算本次模考分数，页面将在 {{ pollCountdown }} 秒后自动刷新结果。</div>
        </div>
        <div class="score_report_summary_panel">
          <div class="score_report_summary_intro">
            <div>
              <div class="score_report_summary_title">Score Overview</div>
              <!-- <div class="score_report_summary_text">总分与四项小分统一展示，便于先看整体结果，再看分项表现。</div> -->
            </div>
          </div>
          <div class="score_report_score_grid">
            <div class="score_report_score_item score_report_score_item_total">
              <div class="score_report_score_circle score_circle_total">{{ communicativeTotalScore }}</div>
              <div class="score_report_score_label">Overall</div>
            </div>
            <div class="score_report_score_item" v-for="item in communicativeSkillsRows" :key="item.key">
              <div class="score_report_score_circle" :class="scoreCircleClass(item.key)">{{ item.score }}</div>
              <div class="score_report_score_label">{{ item.label }}</div>
            </div>
          </div>
        </div>
        <div style="background-color: #ffffff;padding: 30px;border-radius: 10px;">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="Score Report" name="first">
              <div class="score_report_card">
                <div class="score_report_header">
                  <!-- <div class="score_report_heading">Score Report</div> -->
                  <div class="score_report_caption">Communicative Skills</div>
                </div>
                <div class="communicative_skills_card">
                  <div class="communicative_skills_scale_row">
                    <div></div>
                    <div class="communicative_skills_scale">
                      <span
                        v-for="tick in communicativeTicks"
                        :key="tick"
                        class="communicative_skills_tick"
                        :style="{ left: communicativeTickPosition(tick) }"
                      >
                        <span class="communicative_skills_tick_label">{{ tick }}</span>
                        <span class="communicative_skills_tick_mark"></span>
                      </span>
                    </div>
                  </div>
                  <div class="communicative_skills_body">
                    <div class="communicative_track_overlay">
                      <div class="communicative_total_line" :style="{ left: communicativeTotalPosition }">
                        <div class="communicative_total_badge">总分 {{ communicativeTotalScore }}</div>
                      </div>
                    </div>
                    <div class="communicative_skill_row" v-for="item in communicativeSkillsRows" :key="item.key">
                      <div class="communicative_skill_label">{{ item.label }}</div>
                      <div class="communicative_skill_track">
                        <div class="communicative_skill_fill" :style="{ width: communicativeScoreWidth(item.score) }"></div>
                        <div class="communicative_skill_value">{{ item.score }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="Speaking" name="second">
              <el-table
                :data="topic_type_list"
                >
                <el-table-column
                  prop="cate_name"
                  label="题型类别"
                  width="180">
                </el-table-column>
                <el-table-column
                  prop="topictype.short_name"
                  label="题型"
                  width="180">
                </el-table-column>
                <el-table-column
                  prop="percent"
                  label="权重"
                  width="180">
                </el-table-column>
                <el-table-column
                  prop="type_percent"
                  label="我的正确率"
                  width="180">
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="Writing" name="third">
              <el-table
                :data="topic_type_list"
                >
                <el-table-column
                  prop="cate_name"
                  label="题型类别"
                  width="180">
                </el-table-column>
                <el-table-column
                  prop="topictype.short_name"
                  label="题型"
                  width="180">
                </el-table-column>
                <el-table-column
                  prop="percent"
                  label="权重"
                  width="180">
                </el-table-column>
                <el-table-column
                  prop="type_percent"
                  label="我的正确率"
                  width="180">
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="Reading" name="fourth">
              <el-table
                :data="topic_type_list"
                >
                <el-table-column
                  prop="cate_name"
                  label="题型类别"
                  width="180">
                </el-table-column>
                <el-table-column
                  prop="topictype.short_name"
                  label="题型"
                  width="180">
                </el-table-column>
                <el-table-column
                  prop="percent"
                  label="权重"
                  width="180">
                </el-table-column>
                <el-table-column
                  prop="type_percent"
                  label="我的正确率"
                  width="180">
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="Listening" name="fifth">
              <el-table
                :data="topic_type_list"
                >
                <el-table-column
                  prop="cate_name"
                  label="题型类别"
                  width="180">
                </el-table-column>
                <el-table-column
                  prop="topictype.short_name"
                  label="题型"
                  width="180">
                </el-table-column>
                <el-table-column
                  prop="percent"
                  label="权重"
                  width="180">
                </el-table-column>
                <el-table-column
                  prop="type_percent"
                  label="我的正确率"
                  width="180">
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div style="background-color: #ffffff;margin-top: 30px;padding: 30px;border-radius: 10px;">
          <el-tabs v-model="activeName2" @tab-click="handleClick2">
            <el-tab-pane label="口语" name="first">
              <div style="margin-top: 30px;" v-for="(item, index) in topic_list1" :key="'list' + index">
                <div style="display: flex;justify-content: space-between;">
                  <div class="topic_type_name topic_type_name_asq" v-if="item.topic_type_id==5">{{ index+1 }}. {{ getTopicTypeDisplayName(item) }} {{ item.topic.number }} {{ getTopicTypeDisplayName(item) }}</div>
                  <div class="topic_type_name topic_type_name_asq" v-else>{{ index+1 }}. {{ getTopicTypeDisplayName(item) }} {{ item.topic.number }} {{ item.topic.name }}</div>
                  <div class="topic_actions">
                    <div class="to_topic_detail" @click="toTopic(item)">查看原题 ></div>
                    <div class="share_button" @click="shareTopic(item)" title="分享题目">分享</div>
                  </div>
                </div>
                <div class="topic_type_timu_box box_sizing" v-if="item.topic.topic_type_id == 1 || item.topic.topic_type_id==26">
                  <span v-for="(item1, index) in getSpeakingTopicShowText(item)" :key="index"
                    :class="{ hand_change: isSelectableShowTextItem(item1) }"
                    @click="isSelectableShowTextItem(item1) ? dianjiClick(item1) : null"
                    v-html="renderShowTextItem(item1)"></span>
                </div>
                <div style="margin-bottom: 24px;" v-if="item.topic_type_id == 2">
                  <mp3-tool ref="mp3" :src-url="item.topic.file"></mp3-tool>
                </div>
                <div class="topic_type_timu_box box_sizing hand_change" style="font-size: 16px;"
                  v-if="item.topic_type_id == 2">
                  <span v-for="(word, wordIndex) in splitTextToWords(item.topic.show_tape_text)"
                    :key="wordIndex"
                    class="clickable_word"
                    @click="dianjiClick(word)">{{ word }} </span>
                </div>
                <div class="topic_type_timu_box box_sizing" style="font-size: 16px;"
                  v-if="item.topic_type_id == 5">
                  {{ item.topic.audio_show_tape_text }}
                </div>
                <div class="topic_type_timu_box box_sizing hand_change" style="font-size: 16px;"
                  v-if="item.topic_type_id == 4 || item.topic_type_id==27">
                  <span v-for="(word, wordIndex) in splitTextToWords(item.topic.audio_content_text)"
                    :key="wordIndex"
                    class="clickable_word"
                    @click="dianjiClick(word)">{{ word }} </span>
                </div>
                <!-- <img class="" v-if="item.topic_type_id == 4 && item.topic.image" style="height: auto;" :src="item.topic.image" /> -->
                <div style="width: 50%;" v-if="item.topic.topic_type_id == 3">
                  <img class="" style="height: auto;" :src="item.topic.image" />
                  <div class="topic_answer" v-html="item.topic.exam_translate"></div>
                </div>
                <div>
                  <div style="margin: 24px 0 16px;color: #666;font-size: 16px;">你的答案：</div>
                  <div class="my_padding box_sizing">
                    <mp3-tool ref="mp3" :src-url="'https://static.yijishen.com'+item.content"></mp3-tool>
                  </div>
                </div>
                <div style="display: flex;justify-content: space-between;">
                  <div style="display: flex;">
                    <div class="btn_view" @click="view_result(item)">评分详情 <span v-if="item.score && item.score.total">({{ item.score.total.score }}/{{ getScoreFull(item) }})</span><span v-else-if="item.score && item.score.score !== undefined">({{ item.score.score }}/{{ getScoreFull(item) }})</span></div>
                    <div class="btn_view" v-if="item.topic_type_id != 2 && item.topic_type_id != 3" @click="view_translate(item)">查看翻译</div>
                  </div>
                  <!-- <div>答题用时：{{  }}</div> -->
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="写作" name="second">
              <div style="margin-top: 30px;" v-for="(item, index) in topic_list2" :key="'list' + index">
                <div style="display: flex;justify-content: space-between;">
                  <div class="topic_type_name topic_type_name_asq">{{ index+1 }}. {{ getTopicTypeDisplayName(item) }} {{ item.topic.number }} {{ item.topic.name }}</div>
                  <div class="topic_actions">
                    <div class="to_topic_detail" @click="toTopic(item)">查看原题 ></div>
                    <div class="share_button" @click="shareTopic(item)" title="分享题目">分享</div>
                  </div>
                </div>
                <div class="topic_type_timu_box box_sizing hand_change">
                  <span
                    v-for="(item1, index1) in item.topic.show_text"
                    :key="index1"
                    class="panding_change"
                    :class="[isShowTextBreak(item1) ? 'panding_change_br' : '', isSelectableShowTextItem(item1) ? 'hand_change' : '']"
                    @click="isSelectableShowTextItem(item1) ? dianjiClick(item1) : null"
                    v-html="renderShowTextItem(item1)"
                  ></span>
                </div>
                <div class="topic_answer" v-html="item.topic.show_tape_text"></div>
                <div>
                  <div style="margin: 24px 0 16px;color: #666;font-size: 16px;">你的答案：</div>
                  <div class="my_padding box_sizing">
                    {{ decodeHtmlText(item.content) }}
                  </div>
                </div>
                <div style="display: flex;justify-content: space-between;">
                  <div style="display: flex;">
                    <div class="btn_view" @click="view_result(item)">评分详情 <span v-if="item.score && item.score.total">({{ item.score.total.score }}/{{ getScoreFull(item) }})</span></div>
                  </div>
                  <!-- <div>答题用时：{{  }}</div> -->
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="阅读" name="third">
              <div style="margin-top: 30px;" v-for="(item, index) in topic_list3" :key="'list' + index">
                <div style="display: flex;justify-content: space-between;">
                  <div class="topic_type_name topic_type_name_asq">{{ index+1 }}. {{ getTopicTypeDisplayName(item) }} {{ item.topic.number }} {{ item.topic.name }}</div>
                  <div class="topic_actions">
                    <div class="to_topic_detail" @click="toTopic(item)">查看原题 ></div>
                    <div class="share_button" @click="shareTopic(item)" title="分享题目">分享</div>
                  </div>
                </div>
                <!--MCS_R-->
                <div class="topic_type_timu_box box_sizing hand_change" v-if="item.topic_type_id==8">
                  <span
                    v-for="(item1, index1) in item.topic.show_text"
                    :key="index1"
                    class="panding_change"
                    :class="{ hand_change: isSelectableShowTextItem(item1) }"
                    @click="isSelectableShowTextItem(item1) ? dianjiClick(item1) : null"
                    v-html="renderShowTextItem(item1)"
                  ></span>
                  <div class="topic_answer" v-html="item.topic.show_tape_text"></div>
                </div>
                <!--MCS_M-->
                <div class="topic_type_timu_box box_sizing hand_change" v-if="item.topic_type_id==9">
                  <span
                    v-for="(item1, index1) in item.topic.show_text"
                    :key="index1"
                    class="panding_change"
                    :class="{ hand_change: isSelectableShowTextItem(item1) }"
                    @click="isSelectableShowTextItem(item1) ? dianjiClick(item1) : null"
                    v-html="renderShowTextItem(item1)"
                  ></span>
                  <div class="topic_answer" v-html="item.topic.show_tape_text"></div>
                </div>
                <!--RO-->
                <div class="topic_type_answer_box box_sizing" v-if="item.topic_type_id == 10">
                  <div
                    class="flex_box box_sizing"
                    v-for="(item1, index1) in item.topic.extend.extend_sort"
                    :key="index1"
                  >
                    <!-- <div class="p17">{{ item1.show_index }}</div> -->
                    <div class="ro_choose">
                      {{ item1.show_index }}) {{ item1.content }}
                    </div>
                  </div>
                  <div class="topic_answer">
                    <div>答案：</div>
                    <div>{{item.topic.extend.daan}}</div>
                  </div>
                </div>
                <!--FIB_R-->
                <div class="topic_type_timu_box box_sizing" v-if="item.topic_type_id==11&&item.topic.extend.FIB">
                  <span v-for="(item1, index1) in item.topic.extend.FIB" :key="index1">
                    <span v-if="item1.index == 0" @click="dianjiClick(item1.word)" v-html="item1.word">
                    </span>
                    <span
                      class="panding_change"
                      :data-txt="item1.word"
                      v-else
                      style="
                        height: 16px;
                        border-bottom: 1px solid rgba(6, 18, 30, 1);
                        /* width: 150px; */
                        text-align: center;
                        margin: 3px;
                      "
                    >
                      <span v-if="item.score && item.score.content && item1.word == item.score.content[item1.word]" style="color: #12d3bf;"
                        @click="dianjiClick(item1.word)">
                        {{item.score.content[item1.word] || ''}}（答案:{{item1.word}}）
                      </span>
                      <span v-else-if="item.score && item.score.content && item.score.content[item1.word]" style="color: #f6704b;"
                        @click="dianjiClick(item1.word)">
                        {{item.score.content[item1.word]}}（答案:{{item1.word}}）
                      </span>
                      <span v-else style="color: #f6704b;"
                        @click="dianjiClick(item1.word)">
                        未选择（答案:{{item1.word}}）
                      </span>
                    </span>
                  </span>
                </div>
                <div v-if="item.topic_type_id==11">
                    <div class="fib_choose">Choices：</div>
                    <div class="ro_choose" v-for="(item,index) in item.topic.extend.keyword" :key="index" @click="dianjiClick(item)">
                      {{ index+1 }}) {{ item }}
                    </div>
                  </div>
                <!--FIB_RW-->
                <div class="topic_type_timu_box box_sizing" v-if="item.topic_type_id==12&&item.topic.extend.FIB_RW">
                  <span v-for="(item1, index1) in item.topic.extend.FIB_RW" :key="index1">
                    <span v-if="item1.index == 0" @click="dianjiClick(item1.word)" v-html="item1.word">
                    </span>
                    <span
                      class="panding_change"
                      v-else
                    >
                      <span v-for="(word,word_index) in item1.word" :key="word_index">
                        <span v-if="word.daan == 1"
                        style="
                          text-align: center;
                          border-bottom: 1px solid rgba(6, 18, 30, 1);
                          margin: 3px;
                        ">
                          <span v-if="item.score && item.score.content && word.word == item.score.content[word.word]" style="color: #12d3bf;"
                            @click="dianjiClick(word.word)">
                            {{item.score.content[word.word] || ''}}（答案:{{word.word}}）
                          </span>
                          <span v-else-if="item.score && item.score.content && item.score.content[word.word]" style="color: #f6704b;"
                            @click="dianjiClick(word.word)">
                            {{item.score.content[word.word]}}（答案:{{word.word}}）
                          </span>
                          <span v-else style="color: #f6704b;"
                            @click="dianjiClick(word.word)">
                            未选择（答案:{{word.word}}）
                          </span>
                        </span>
                      </span>
                    </span>
                  </span>
                </div>
                <div>
                  <div style="margin: 24px 0 16px;color: #666;font-size: 16px;">你的答案：</div>
                  <div class="my_padding box_sizing" v-if="item.topic_type_id == 11 || item.topic_type_id == 12">
                    <div v-if="item.score">{{ Object.values(item.score.content).join(", ") }}</div>
                  </div>
                  <div class="my_padding box_sizing" v-else>
                     {{ decodeHtmlText(item.content) }}
                  </div>
                </div>
                <div style="display: flex;justify-content: space-between;">
                  <div style="display: flex;">
                    <div class="btn_view" @click="view_result(item)">评分详情 <span v-if="item.score && item.score.total">({{ item.score.total.score }}/{{ getScoreFull(item) }})</span><span v-else-if="item.score && item.score.score !== undefined">({{ item.score.score }}/{{ getScoreFull(item) }})</span></div>
                    <div class="btn_view" @click="view_translate(item)">查看翻译</div>
                  </div>
                  <!-- <div>答题用时：{{  }}</div> -->
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="听力" name="fourth">
              <div style="margin-top: 30px;" v-for="(item, index) in topic_list4" :key="'list' + index">
                <div style="display: flex;justify-content: space-between;">
                  <div class="topic_type_name topic_type_name_asq">{{ index+1 }}. {{ getTopicTypeDisplayName(item) }} {{ item.topic.number }} {{ item.topic.name }}</div>
                  <div class="topic_actions">
                    <div class="to_topic_detail" @click="toTopic(item)">查看原题 ></div>
                    <div class="share_button" @click="shareTopic(item)" title="分享题目">分享</div>
                  </div>
                </div>
                <div style="margin-bottom: 24px;">
                  <mp3-tool ref="mp3" :src-url="item.topic.file"></mp3-tool>
                </div>
                <!--SST-->
                <div class="topic_type_timu_box box_sizing hand_change" v-if="item.topic_type_id==13">
                  <span v-if="item.topic.extend.is_switch == 0"
                    v-html="item.topic.show_tape_text"
                  ></span>
                  <span v-else
                    v-html="item.topic.extend.content"
                  ></span>
                </div>
                <!--MCM_L-->
                <div v-if="item.topic_type_id==14">
                  <div class="topic_type_timu_box box_sizing hand_change">
                    <div class="common_title2" v-html="item.topic.extend.content"></div>
                    <div class="common_title">Question：</div>
                    <div class="common_title2">
                      <div>{{ item.topic.extend.topic }}</div>
                    </div>
                    <div class="common_title">Choices：</div>
                    <div
                      v-for="(item1, index1) in item.topic.extend.extend_MA"
                      :key="index1"
                      class="panding_change"
                    >
                      <span>{{ item1.key }}. </span>
                      <span>{{ item1.content }}</span>
                    </div>
                  </div>
                  <div class="topic_answer">
                    <div>答案：</div>
                    <div>{{item.score.daan}}</div>
                  </div>
                </div>
                <!--FIB_L-->
                <div class="topic_type_timu_box box_sizing" v-if="item.topic_type_id==15&&item.topic.extend.FIB">
                  <span v-for="(item1, index1) in item.topic.extend.FIB" :key="index1">
                    <span v-if="item1.index == 0" @click="dianjiClick(item1.word)" v-html="item1.word">
                    </span>
                    <span
                      class="panding_change"
                      :data-txt="item1.word"
                      v-else
                      style="
                        height: 16px;
                        border-bottom: 1px solid rgba(6, 18, 30, 1);
                        /* width: 150px; */
                        text-align: center;
                        margin: 3px;
                      "
                    >
                      <span v-if="item.score && item.score.content && item1.word == item.score.content[item1.word]" style="color: #12d3bf;"
                        @click="dianjiClick(item1.word)">
                        {{item.score.content[item1.word] || ''}}（答案:{{item1.word}}）
                      </span>
                      <span v-else-if="item.score && item.score.content && item.score.content[item1.word]" style="color: #f6704b;"
                        @click="dianjiClick(item1.word)">
                        {{item.score.content[item1.word]}}（答案:{{item1.word}}）
                      </span>
                      <span v-else style="color: #f6704b;">
                        未填写（答案:{{item1.word}}）
                      </span>
                    </span>
                  </span>
                </div>
                <!--HCS-->
                <div v-if="item.topic_type_id==16||item.topic_type_id==18">
                  <div class="topic_type_timu_box box_sizing hand_change">
                    <div class="common_title2" v-html="item.topic.extend.content"></div>
                    <div class="common_title">Question：</div>
                    <div class="panding_change" v-if="item.topic_type_id==16">
                      <span>Click on the paragraph that best relates to the recording.</span>
                    </div>
                    <div class="panding_change" v-if="item.topic_type_id==18">
                      <span>At the end of the recording, the last word or group of words has been replaced by a beep. Select the correct option to complete the recording.</span>
                    </div>
                    <div class="common_title">Choices：</div>
                    <div
                      v-for="(item1, index1) in item.topic.extend.extend_SA"
                      :key="index1"
                      class="panding_change"
                      @click="dianjiClick(item1)"
                    >
                      <span>{{ item1.key }}. {{ item1.content }}</span>
                    </div>
                  </div>
                  <div class="topic_answer">
                    <div>答案：</div>
                    <div>{{item.score.daan}}</div>
                  </div>
                </div>
                <!--MCS_L-->
                <div v-if="item.topic_type_id==17">
                  <div class="topic_type_timu_box box_sizing hand_change">
                    <div class="common_title2" v-html="item.topic.extend.content"></div>
                    <div class="common_title">Question：</div>
                    <div class="common_title2">
                      <div>{{ item.topic.extend.topic }}</div>
                    </div>
                    <div class="common_title">Choices：</div>
                    <div
                      v-for="(item1, index1) in item.topic.extend.extend_SA"
                      :key="index1"
                      class="panding_change"
                      @click="dianjiClick(item1)"
                    >
                      <span>{{ item1.key }}. </span>
                      <span>{{ item1.content }}</span>
                    </div>
                  </div>
                  <div class="topic_answer">
                    <div>答案：</div>
                    <div>{{item.score.daan}}</div>
                  </div>
                </div>
                <!--HIW-->
                <div class="topic_type_timu_box box_sizing" v-if="item.topic_type_id==19&&item.topic.extend.HIW">
                  <span
                    v-for="(item1, index1) in item.topic.extend.HIW"
                    :key="index1"
                    class="cuoci_ans hand_change"
                    >
                    <template v-if="item1.index == 1">
                      <span style="color: #f6704b;" @click="dianjiClick(item1.word)">{{ item1.word }}</span>
                      <span style="color: #333;"> / </span>
                      <span style="color: #12d3bf;" @click="dianjiClick2(item,index1)">{{ getHIWCorrectAnswer(item, index1) }}</span>
                    </template>
                    <span v-else v-html="item1.word" @click="dianjiClick(item1.word)"></span>
                  </span>
                </div>
                <!--SMW-->
                <!-- <div v-if="item.topic_type_id==18">
                  <div class="topic_answer">
                    <div>答案：</div>
                    <div>{{item.score.daan}}</div>
                  </div>
                </div> -->
                <!--WFD-->
                <div class="topic_type_timu_box box_sizing hand_change" v-if="item.topic_type_id==20">
                  <div class="common_title2" v-html="item.topic.show_tape_text">
                  </div>
                </div>
                <div>
                  <div style="margin: 24px 0 16px;color: #666;font-size: 16px;">你的答案：</div>
                  <div class="my_padding box_sizing" v-if="item.topic_type_id == 15 || item.topic_type_id == 12">
                    {{ Object.values(item.score.content).join(", ") }}
                  </div>
                  <div class="my_padding box_sizing" v-else>
                     {{ decodeHtmlText(item.content) }}
                  </div>
                </div>
                <div style="display: flex;justify-content: space-between;">
                  <div style="display: flex;">
                    <div class="btn_view" @click="view_result(item)">评分详情 <span v-if="item.score && item.score.total">({{ item.score.total.score }}/{{ getScoreFull(item) }})</span><span v-else-if="item.score && item.score.score !== undefined">({{ item.score.score }}/{{ getScoreFull(item) }})</span></div>
                    <div class="btn_view" v-if="item.topic.topic_type_id != 20" @click="view_translate(item)">查看翻译</div>
                  </div>
                  <!-- <div>答题用时：{{  }}</div> -->
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        </template>
      </div>
      <airesult ref="result"></airesult>
      <translate ref="translate"></translate>
      <footers></footers>
    </div>
  </template>

  <script>
  import headers from "@/components/headers";
  import footers from "@/components/footders";
  import left from "@/components/left";
  import right from "@/components/right";
  import scrollpage from "@/components/scrollpage";
  import "@/css/pagePing.css";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart,LineChart } from "echarts/charts";
import Mp3Tool from "@/components/mp3Tool.vue";
import Word from "@/components/word.vue";
import airesult from "@/components/airesult.vue";
import translate from "@/components/translate.vue";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent
} from "echarts/components";

use([
  CanvasRenderer,
  BarChart,
  LineChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent
]);

  var _this;
  export default {
    components: {
      headers,
      footers,
      left,
      right,
      scrollpage,
      Mp3Tool,
      Word,
      airesult,
      translate
    },
    data() {
      return {
        current: 0,
        mokaoId: [],
        activeName: 'first',
        activeName2: 'first',
        id: "",
        name: "",
        user_exam_id: "",
        detail: {},
        content: '',
        scores: [],
        average: 0,
        topic_percent: [],
        topic_type_list: [],
        topic_list1: [],
        topic_list2: [],
        topic_list3: [],
        topic_list4: [],
        speaking_arr: [1,2,3,4,5,26,27],
        userInfo: null,        // 答题用户信息
        examTitle: '',         // 试卷标题
        examCreatetime: '',    // 答题时间
        isShareView: false,    // 是否为分享查看模式
        pageLoading: true,
        scorePending: false,
        pollCountdown: 5,
        scorePollTimer: null,
        scorePollCountdownTimer: null,
        // 图表配置
        option: {
          title: {
            text: 'Communicative Skills',
            left: 0,
            top: 0,
            textStyle: {
              fontSize: 20,
              fontWeight: 600,
              color: '#101828'
            }
          },
          timeLen: 0,
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            },
            backgroundColor: 'rgba(16, 24, 40, 0.92)',
            borderWidth: 0,
            textStyle: {
              color: '#ffffff'
            }
          },
          legend: {
            data: ['分数', '总分'],
            top: 4,
            right: 0,
            icon: 'roundRect',
            itemWidth: 10,
            itemHeight: 10,
            textStyle: {
              color: '#667085',
              fontSize: 12
            }
          },
          grid: {
            top: 56,
            left: 96,
            right: 36,
            bottom: 24
          },
          xAxis: {
            type: 'value',
            min: 0,
            max: 90,
            splitNumber: 9,
            axisLabel: {
              color: '#98a2b3',
              fontSize: 11
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                color: '#edf2f7'
              }
            }
          },
          yAxis: {
            type: 'category',
            data: ['Listening', 'Reading', 'Speaking', 'Writing'],
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              color: '#344054',
              fontSize: 13,
              fontWeight: 500,
              margin: 18
            }
          },
          series: [
            {
              name: '分数',
              type: 'bar',
              barWidth: 14,
              data: [0, 0, 0, 0],
              itemStyle: {
                color: '#f6704b',
                borderRadius: [0, 999, 999, 0]
              },
              label: {
                show: true,
                position: 'right',
                distance: 10,
                color: '#101828',
                fontSize: 12,
                formatter: '{c}'
              }
            },
            {
              name: '总分',
              type: 'line',
              data: [],
              symbol: 'none',
              lineStyle: {
                opacity: 0
              },
              tooltip: {
                show: false
              },
              markLine: {
                symbol: ['none', 'none'],
                silent: true,
                animation: false,
                label: {
                  show: true,
                  formatter: '总分 {c}',
                  position: 'insideEndTop',
                  distance: 6,
                  fontSize: 11,
                  color: '#667085',
                  backgroundColor: '#ffffff',
                  padding: [2, 4, 2, 4]
                },
                lineStyle: {
                  color: '#98a2b3',
                  type: 'dashed',
                  width: 1
                },
                data: [{
                  name: '总分',
                  xAxis: 0,
                  label: { show: true }
                }]
              }
            }
          ]
        }
      };
    },
    computed: {
      filteredShowText(e) {
        return (e.topic.show_text || []).filter(item => !this.isShowTextBreak(item));
      },
      skillsProfileRows() {
        return this.buildSkillsProfileRows();
      },
      communicativeSkillsRows() {
        return [
          { key: 'listening', label: 'Listening', score: this.getOverviewScore(this.scores[0]) },
          { key: 'reading', label: 'Reading', score: this.getOverviewScore(this.scores[1]) },
          { key: 'speaking', label: 'Speaking', score: this.getOverviewScore(this.scores[2]) },
          { key: 'writing', label: 'Writing', score: this.getOverviewScore(this.scores[3]) }
        ];
      },
      communicativeTotalScore() {
        if (!this.communicativeSkillsRows.length) {
          return '10.0';
        }
        const total = this.communicativeSkillsRows.reduce((sum, item) => sum + item.score, 0);
        return (total / this.communicativeSkillsRows.length).toFixed(1);
      },
      communicativeTotalPosition() {
        const total = Number(this.communicativeTotalScore);
        return `${Math.max(0, Math.min(100, (total / 90) * 100)).toFixed(4)}%`;
      },
      communicativeTicks() {
        return [0, 10, 20, 30, 40, 50, 60, 70, 80, 90];
      }
    },
    created() {
      _this = this;
        _this.getParams();
    },
    beforeDestroy() {
      this.stopScorePolling();
    },
    methods: {
        resetScoreData() {
          this.scores = [];
          this.topic_percent = [];
          this.topic_type_list = [];
          this.topic_list1 = [];
          this.topic_list2 = [];
          this.topic_list3 = [];
          this.topic_list4 = [];
          this.userInfo = null;
          this.examTitle = '';
          this.examCreatetime = '';
        },
        hasCompleteScoreResult(res) {
          if (!res || res.code != 1 || !res.data || !Array.isArray(res.data.topic_percent)) {
            return false;
          }
          const topicLists = res.data.topic_percent.reduce((total, item) => {
            return total + ((item && Array.isArray(item.topic_list)) ? item.topic_list.length : 0);
          }, 0);
          const topicTypeLists = res.data.topic_percent.reduce((total, item) => {
            return total + ((item && Array.isArray(item.topic_type_list)) ? item.topic_type_list.length : 0);
          }, 0);
          const scoreValues = [res.data.listening, res.data.reading, res.data.speaking, res.data.writing];
          const hasScoreValue = scoreValues.some(score => score !== null && score !== undefined && score !== '');
          return topicLists > 0 && topicTypeLists > 0 && hasScoreValue;
        },
        startScorePolling() {
          if (this.isShareView || this.scorePollTimer || this.scorePollCountdownTimer) {
            return;
          }
          this.scorePending = true;
          this.pollCountdown = 5;
          this.scorePollCountdownTimer = setInterval(() => {
            if (this.pollCountdown <= 1) {
              this.pollCountdown = 5;
            } else {
              this.pollCountdown -= 1;
            }
          }, 1000);
          this.scorePollTimer = setInterval(() => {
            this.pollCountdown = 5;
            this.getScore(true);
          }, 5000);
        },
        stopScorePolling() {
          if (this.scorePollTimer) {
            clearInterval(this.scorePollTimer);
            this.scorePollTimer = null;
          }
          if (this.scorePollCountdownTimer) {
            clearInterval(this.scorePollCountdownTimer);
            this.scorePollCountdownTimer = null;
          }
          this.pollCountdown = 5;
        },
        normalizeShowTextItem(item) {
          if (item && typeof item === 'object' && !Array.isArray(item)) {
            return item;
          }
          return {
            word: item,
            is_select: item && item !== '&nbsp;' && item !== '<br/>' ? 1 : 0,
          };
        },
        getShowTextWord(item) {
          const value = this.normalizeShowTextItem(item).word;
          return value == null ? '' : String(value);
        },
        decodeHtmlText(value) {
          if (value == null) return '';
          const container = document.createElement('div');
          container.innerHTML = String(value);
          return container.textContent || container.innerText || '';
        },
        getOverviewScore(score) {
          const value = Number(score);
          if (Number.isNaN(value)) return 10;
          return Math.max(10, Number(value.toFixed(1)));
        },
        isSelectableShowTextItem(item) {
          return Number(this.normalizeShowTextItem(item).is_select) === 1;
        },
        isShowTextBreak(item) {
          return /^<br\s*\/?>$/i.test(this.getShowTextWord(item));
        },
        renderShowTextItem(item) {
          const word = this.getShowTextWord(item);
          if (this.isShowTextBreak(item)) {
            return '<br/>';
          }
          return word.replace(/ /g, '&nbsp;');
        },
        getSpeakingTopicShowText(item) {
          if (!item || !item.topic) {
            return [];
          }

          if (item.topic_type_id == 1 && item.word_data) {
            const words = this.splitTextToWords(item.word_data);
            return words.flatMap((word, index) => {
              const items = [{
                word,
                is_select: 1,
              }];
              if (index < words.length - 1) {
                items.push({
                  word: ' ',
                  is_select: 0,
                });
              }
              return items;
            });
          }

          return item.topic.show_text || [];
        },
        normalizeTopicAlias(rawAlias, topicTypeId) {
          const aliasByTypeId = {
            1: 'RA',
            2: 'RS',
            3: 'DI',
            4: 'RL',
            5: 'ASQ',
            6: 'WE',
            7: 'SWT',
            10: 'RO',
            11: 'FIB_DRAG&DROP',
            12: 'FIB_DROPDOWN',
            13: 'SST',
            15: 'FIBL',
            16: 'HCS',
            18: 'SMW',
            19: 'HIW',
            20: 'WFD',
            21: 'WFD',
            22: 'RTS',
            23: 'WE',
            24: 'SWT',
            25: 'WFD',
            26: 'RTS',
            27: 'SGD'
          };

          if (aliasByTypeId[topicTypeId]) {
            return aliasByTypeId[topicTypeId];
          }

          const normalized = String(rawAlias || '')
            .toUpperCase()
            .replace(/\s+/g, '')
            .replace(/[()]/g, '')
            .replace(/-/g, '_');

          const aliasMap = {
            FIB_RW: 'FIB_DROPDOWN',
            FIBRW: 'FIB_DROPDOWN',
            FIB_R: 'FIB_DRAG&DROP',
            FIBR: 'FIB_DRAG&DROP',
            FIB_L: 'FIBL',
            WFDCORE: 'WFD',
            WE_C: 'WE',
            WEC: 'WE',
            SWT_C: 'SWT',
            SWTC: 'SWT',
            RTS_C: 'RTS',
            RTSC: 'RTS'
          };

          return aliasMap[normalized] || normalized;
        },
        getTopicAlias(item) {
          if (!item) {
            return '';
          }
          const rawAlias = item.topictype && item.topictype.short_name ? item.topictype.short_name : '';
          return this.normalizeTopicAlias(rawAlias, item.topic_type_id);
        },
        getItemEarnedScore(item) {
          if (!item || !item.score) {
            return null;
          }
          if (item.score.total && item.score.total.score !== undefined) {
            const totalScore = Number(item.score.total.score);
            return Number.isNaN(totalScore) ? null : totalScore;
          }
          if (item.score.score !== undefined) {
            const score = Number(item.score.score);
            return Number.isNaN(score) ? null : score;
          }
          return null;
        },
        getAllExamTopicItems() {
          return []
            .concat(this.topic_list1 || [])
            .concat(this.topic_list2 || [])
            .concat(this.topic_list3 || [])
            .concat(this.topic_list4 || []);
        },
        buildTopicAliasScoreMap() {
          const scoreMap = {};
          const aggregateMap = {};

          this.getAllExamTopicItems().forEach((item) => {
            const alias = this.getTopicAlias(item);
            const earned = this.getItemEarnedScore(item);
            const full = Number(this.getScoreFull(item));

            if (!alias || earned === null || !full || Number.isNaN(full)) {
              return;
            }

            if (!aggregateMap[alias]) {
              aggregateMap[alias] = { earned: 0, full: 0 };
            }

            aggregateMap[alias].earned += earned;
            aggregateMap[alias].full += full;
          });

          Object.keys(aggregateMap).forEach((alias) => {
            const item = aggregateMap[alias];
            if (!item.full) {
              return;
            }
            scoreMap[alias] = Math.max(0, Math.min(100, (item.earned / item.full) * 100));
          });

          return scoreMap;
        },
        weightedAverageByAlias(scoreMap, configs) {
          let weightedTotal = 0;
          let totalWeight = 0;

          configs.forEach((config) => {
            const value = scoreMap[config.key];
            if (typeof value !== 'number' || Number.isNaN(value)) {
              return;
            }
            weightedTotal += value * config.weight;
            totalWeight += config.weight;
          });

          if (!totalWeight) {
            return null;
          }

          return weightedTotal / totalWeight;
        },
        combineWeightedSections(sections) {
          let weightedTotal = 0;
          let totalWeight = 0;

          sections.forEach((section) => {
            if (typeof section.value !== 'number' || Number.isNaN(section.value)) {
              return;
            }
            weightedTotal += section.value * section.weight;
            totalWeight += section.weight;
          });

          if (!totalWeight) {
            return null;
          }

          return weightedTotal / totalWeight;
        },
        buildSkillsProfileRows() {
          const scoreMap = this.buildTopicAliasScoreMap();
          const openResponseSpeaking = this.weightedAverageByAlias(scoreMap, [
            { key: 'DI', weight: 31 },
            { key: 'RL', weight: 13 },
            { key: 'SGD', weight: 19 },
            { key: 'RTS', weight: 13 }
          ]);
          const extendedWriting = this.weightedAverageByAlias(scoreMap, [
            { key: 'SWT', weight: 28 },
            { key: 'WE', weight: 31 },
            { key: 'SST', weight: 18 }
          ]);
          const shortSpeaking = this.weightedAverageByAlias(scoreMap, [
            { key: 'RA', weight: 9 },
            { key: 'RS', weight: 16 }
          ]);
          const multipleSkillsBase = this.weightedAverageByAlias(scoreMap, [
            { key: 'RS', weight: 17 },
            { key: 'RL', weight: 13 },
            { key: 'SGD', weight: 20 },
            { key: 'HCS', weight: 2 },
            { key: 'HIW', weight: 8 },
            { key: 'WFD', weight: 13 },
            { key: 'SST', weight: 10 }
          ]);
          const singleSkillsListening = this.weightedAverageByAlias(scoreMap, [
            { key: 'ASQ', weight: 4 },
            { key: 'FIBL', weight: 8 },
            { key: 'SMW', weight: 1 }
          ]);
          const singleSkillsReading = this.weightedAverageByAlias(scoreMap, [
            { key: 'FIB_DROPDOWN', weight: 25 },
            { key: 'RO', weight: 9 },
            { key: 'FIB_DRAG&DROP', weight: 20 }
          ]);
          const rows = [
            {
              key: 'open-response-speaking-writing',
              label: 'Open Response Speaking and Writing',
              cnLabel: '开放式口语写作',
              aliasText: 'DI, RL, SGD, RTS, SWT, WE, SST',
              score: this.combineWeightedSections([
                { value: openResponseSpeaking, weight: 50 },
                { value: extendedWriting, weight: 50 }
              ])
            },
            {
              key: 'reproducing-spoken-written-language',
              label: 'Reproducing Spoken and Written Language',
              cnLabel: '重现音频或文字',
              aliasText: 'RA, RS, WFD',
              score: this.combineWeightedSections([
                { value: shortSpeaking, weight: 50 },
                { value: scoreMap.WFD, weight: 50 }
              ])
            },
            {
              key: 'extended-writing',
              label: 'Extended Writing',
              cnLabel: '长篇写作',
              aliasText: 'SWT, WE, SST',
              score: extendedWriting
            },
            {
              key: 'short-writing',
              label: 'Short Writing',
              cnLabel: '短篇写作',
              aliasText: 'WFD',
              score: typeof scoreMap.WFD === 'number' ? scoreMap.WFD : null
            },
            {
              key: 'extended-speaking',
              label: 'Extended Speaking',
              cnLabel: '长篇口语',
              aliasText: 'DI, RL, SGD, RTS',
              score: openResponseSpeaking
            },
            {
              key: 'short-speaking',
              label: 'Short Speaking',
              cnLabel: '短篇口语',
              aliasText: 'RA, RS',
              score: shortSpeaking
            },
            {
              key: 'multiple-skills-comprehension',
              label: 'Multiple-skills Comprehension',
              cnLabel: '多技能理解',
              aliasText: 'RS, RL, SGD, HCS, HIW, WFD, SST, SWT',
              score: this.combineWeightedSections([
                { value: multipleSkillsBase, weight: 50 },
                { value: scoreMap.SWT, weight: 50 }
              ])
            },
            {
              key: 'single-skill-comprehension',
              label: 'Single-skill Comprehension',
              cnLabel: '单技能理解',
              aliasText: 'ASQ, FIBL, SMW, RTS, FIB_Dropdown, RO, FIB_Drag&Drop',
              score: this.combineWeightedSections([
                { value: singleSkillsListening, weight: 30 },
                { value: scoreMap.RTS, weight: 10 },
                { value: singleSkillsReading, weight: 60 }
              ])
            }
          ];

          return rows.map((row) => ({
            ...row,
            score: typeof row.score === 'number' && !Number.isNaN(row.score)
              ? Number(Math.max(10, row.score).toFixed(2))
              : 10
          }));
        },
        profileBarWidth(score) {
          if (typeof score !== 'number' || Number.isNaN(score)) {
            return '10%';
          }
          return `${Math.max(10, Math.min(100, score)).toFixed(2)}%`;
        },
        scoreCircleClass(key) {
          const classMap = {
            listening: 'score_circle_listening',
            reading: 'score_circle_reading',
            speaking: 'score_circle_speaking',
            writing: 'score_circle_writing'
          };
          return classMap[key] || 'score_circle_default';
        },
        communicativeTickPosition(tick) {
          const value = Number(tick) || 0;
          return `${Math.max(0, Math.min(100, (value / 90) * 100)).toFixed(4)}%`;
        },
        communicativeScoreWidth(score) {
          if (typeof score !== 'number' || Number.isNaN(score)) {
            return `${((10 / 90) * 100).toFixed(2)}%`;
          }
          return `${Math.max(10 / 90 * 100, Math.min(100, (score / 90) * 100)).toFixed(2)}%`;
        },
        /**
         * 规范化多选题选项字符串
         * @param {String} value - 原始选项字符串（如 "B,C,F"）
         * @returns {String[]} 选项数组（去重、去空、统一大写）
         */
        normalizeChoiceString(value) {
          if (!value || typeof value !== 'string') {
            return [];
          }
          const parts = value
            .split(/[,，;；\s]+/)
            .map((v) => String(v).trim().toUpperCase())
            .filter((v) => v);
          return Array.from(new Set(parts));
        },

        /**
         * 计算多选题得分：只统计“选中且正确”的数量（交集大小），不做负分抵消
         * @param {String} userContent - 用户作答内容
         * @param {String} correctAnswer - 正确答案
         * @returns {{score: number, full: number}} 计算出的得分与满分
         */
        calcMcmScore(userContent, correctAnswer) {
          const userChoices = this.normalizeChoiceString(userContent);
          const correctChoices = this.normalizeChoiceString(correctAnswer);
          const correctSet = new Set(correctChoices);
          const score = userChoices.reduce((acc, c) => acc + (correctSet.has(c) ? 1 : 0), 0);
          return {
            score,
            full: correctChoices.length
          };
        },

        /**
         * 修正模考成绩列表中 MCM 多选题的得分字段
         * @param {Object} item - 题目结果项
         * @returns {void} 无返回值，直接在 item 上进行字段修正
         */
        fixMcmScoreForExamItem(item) {
          if (!item || (item.topic_type_id !== 9 && item.topic_type_id !== 14)) {
            return;
          }
          if (!item.score) {
            return;
          }
          const correctAnswer = item.score.daan || (item.topic && item.topic.extend && item.topic.extend.daan);
          const { score, full } = this.calcMcmScore(item.content, correctAnswer);

          if (item.score.total && typeof item.score.total === 'object') {
            item.score.total.score = score;
            item.score.total.full = full;
          }
          if (item.score.content_score && typeof item.score.content_score === 'object') {
            item.score.content_score.score = score;
            item.score.content_score.full = full;
          }
          if (typeof item.score.score === 'number') {
            item.score.score = score;
          }
          if (typeof item.score.full === 'number') {
            item.score.full = full;
          }
        },

        /**
         * 批量修正 topic_list 中的 MCM 多选题和 RO 题型得分
         * @param {Array} topicList - 题目列表
         * @returns {Array} 修正后的同一引用列表
         */
        fixMcmScoreInTopicList(topicList) {
          if (!Array.isArray(topicList)) {
            return topicList;
          }
          return topicList.map((item) => {
            if (item && typeof item === 'object') {
              item = { ...item, content: this.decodeHtmlText(item.content) };
            }
            this.fixMcmScoreForExamItem(item);
            this.fixROScoreForExamItem(item);
            this.fixHIWScoreForExamItem(item);
            return item;
          });
        },

        /**
         * 计算 RO 题型得分：两个连续选项相同才得分
         * @param {String|Array} userContent - 用户作答内容
         * @param {String|Array} correctAnswer - 正确答案
         * @returns {{score: number, full: number}} 计算出的得分与满分
         */
        calcROScore(userContent, correctAnswer) {
          const userArr = this.normalizeROAnswer(userContent);
          const correctArr = this.normalizeROAnswer(correctAnswer);

          if (correctArr.length < 2) {
            return { score: 0, full: 0 };
          }

          // 满分 = 选项数 - 1（相邻对的数量）
          const full = correctArr.length - 1;

          // 构建正确答案的相邻对集合
          const correctPairs = new Set();
          for (let i = 0; i < correctArr.length - 1; i++) {
            correctPairs.add(`${correctArr[i]},${correctArr[i + 1]}`);
          }

          // 计算用户答案中正确的相邻对数量
          let score = 0;
          for (let i = 0; i < userArr.length - 1; i++) {
            const pair = `${userArr[i]},${userArr[i + 1]}`;
            if (correctPairs.has(pair)) {
              score++;
            }
          }

          return { score, full };
        },

        /**
         * 规范化 RO 题型答案为数组
         * @param {String|Array} answer - 原始答案
         * @returns {String[]} 答案数组
         */
        normalizeROAnswer(answer) {
          if (!answer) {
            return [];
          }
          if (Array.isArray(answer)) {
            return answer.map(item => String(item).trim()).filter(item => item);
          }
          if (typeof answer === 'string') {
            return answer.split(/[,，;；\s]+/).map(item => item.trim()).filter(item => item);
          }
          return [];
        },

        /**
         * 修正模考成绩列表中 RO 题型的得分字段（连续配对计分）
         * @param {Object} item - 题目结果项
         * @returns {void} 无返回值，直接在 item 上进行字段修正
         */
        fixROScoreForExamItem(item) {
          if (!item || item.topic_type_id !== 10) {
            return;
          }
          if (!item.score) {
            item.score = {};
          }
          const correctAnswer = item.score.daan || (item.topic && item.topic.extend && item.topic.extend.daan);
          const { score, full } = this.calcROScore(item.content, correctAnswer);

          if (item.score.total && typeof item.score.total === 'object') {
            item.score.total.score = score;
            item.score.total.full = full;
          } else {
            item.score.total = { score, full };
          }
          if (item.score.content_score && typeof item.score.content_score === 'object') {
            item.score.content_score.score = score;
            item.score.content_score.full = full;
          }
          if (typeof item.score.score === 'number') {
            item.score.score = score;
          }
          if (typeof item.score.full === 'number') {
            item.score.full = full;
          }
        },

        /**
         * 计算 HIW 题型得分：content 数组中的单词如果在 return 字段的 key 中，则得 1 分
         * @param {Array} contentArr - score.content 数组
         * @param {Object} returnObj - score.return 对象
         * @param {String|Array} correctAnswer - 正确答案
         * @returns {{score: number, full: number}} 计算出的得分与满分
         */
        calcHIWScore(contentArr, returnObj, correctAnswer) {
          // 规范化正确答案为数组
          const correctArr = this.normalizeHIWAnswer(correctAnswer);

          if (correctArr.length === 0) {
            return { score: 0, full: 0 };
          }

          // 满分 = 正确答案的单词数量
          const full = correctArr.length;

          // 如果没有 content 数组或 return 对象，返回 0 分
          if (!Array.isArray(contentArr) || !returnObj || typeof returnObj !== 'object') {
            return { score: 0, full };
          }

          // 获取 return 对象的所有 key
          const returnKeys = Object.keys(returnObj).map(key => key.toLowerCase());

          // 遍历 content 数组，检查是否在 return 的 key 中
          let score = 0;
          contentArr.forEach(word => {
            if (word && returnKeys.includes(String(word).toLowerCase())) {
              score++;
            }
          });

          return { score, full };
        },

        /**
         * 规范化 HIW 题型答案为数组
         * @param {String|Array} answer - 原始答案
         * @returns {String[]} 答案数组
         */
        normalizeHIWAnswer(answer) {
          if (!answer) {
            return [];
          }
          if (Array.isArray(answer)) {
            return answer.map(item => String(item).trim()).filter(item => item);
          }
          if (typeof answer === 'string') {
            return answer.split(/[,，;；\s]+/).map(item => item.trim()).filter(item => item);
          }
          return [];
        },

        /**
         * 修正模考成绩列表中 HIW 题型的得分字段
         * @param {Object} item - 题目结果项
         * @returns {void} 无返回值，直接在 item 上进行字段修正
         */
        fixHIWScoreForExamItem(item) {
          if (!item || item.topic_type_id !== 19) {
            return;
          }
          if (!item.score) {
            item.score = {};
          }
          const correctAnswer = item.score.daan || (item.topic && item.topic.extend && item.topic.extend.daan);
          const contentArr = item.score.content;
          const returnObj = item.score.return;
          const { score, full } = this.calcHIWScore(contentArr, returnObj, correctAnswer);

          if (item.score.total && typeof item.score.total === 'object') {
            item.score.total.score = score;
            item.score.total.full = full;
          } else {
            item.score.total = { score, full };
          }
          if (item.score.content_score && typeof item.score.content_score === 'object') {
            item.score.content_score.score = score;
            item.score.content_score.full = full;
          }
          if (typeof item.score.score === 'number') {
            item.score.score = score;
          }
          if (typeof item.score.full === 'number') {
            item.score.full = full;
          }
        },

        /**
         * 获取 FIB_R/FIB_L 的正确答案列表（按空位顺序）
         * @param {Array} fib - 题目 extend.FIB
         * @returns {String[]} 正确答案数组
         */
        getFibAnswersFromFIB(fib) {
          if (!Array.isArray(fib)) {
            return [];
          }
          return fib
            .filter((item) => item && item.index !== 0)
            .map((item) => (item.word === undefined || item.word === null ? '' : String(item.word)));
        },

        /**
         * 获取 FIB_RW 的正确答案列表（按空位顺序）
         * @param {Array} fibRw - 题目 extend.FIB_RW
         * @returns {String[]} 正确答案数组
         */
        getFibAnswersFromFIBRW(fibRw) {
          if (!Array.isArray(fibRw)) {
            return [];
          }
          const answers = [];
          fibRw.forEach((part) => {
            if (!part || part.index === 0) {
              return;
            }
            if (Array.isArray(part.word)) {
              const correct = part.word.find((w) => w && w.daan === 1);
              answers.push(correct && correct.word !== undefined && correct.word !== null ? String(correct.word) : '');
              return;
            }
            answers.push('');
          });
          return answers;
        },

        /**
         * 从题目结构中提取 FIB 类题型的正确答案列表（按空位顺序）
         * @param {Object} topic - 题目对象（包含 extend）
         * @param {Number} topicTypeId - 题型 ID
         * @returns {String[]} 正确答案数组
         */
        getFibCorrectAnswersFromTopic(topic, topicTypeId) {
          if (!topic || !topic.extend) {
            return [];
          }
          if (topicTypeId === 12) {
            return this.getFibAnswersFromFIBRW(topic.extend.FIB_RW);
          }
          if (topicTypeId === 11 || topicTypeId === 15) {
            return this.getFibAnswersFromFIB(topic.extend.FIB);
          }
          return [];
        },

        /**
         * 获取题目评分详情显示的满分值（FIB类题型使用正确答案数量）
         * @param {Object} item - 题目结果项
         * @returns {Number} 满分值
         */
        getScoreFull(item) {
          if (!item || !item.score) {
            return 0;
          }
          // FIB类题型使用正确答案数量作为满分
          if (item.topic_type_id === 11 || item.topic_type_id === 12 || item.topic_type_id === 15) {
            const correctAnswers = this.getFibCorrectAnswersFromTopic(item.topic, item.topic_type_id);
            if (correctAnswers.length > 0) {
              return correctAnswers.length;
            }
          }
          // 其他题型使用原有逻辑
          if (item.score.total && item.score.total.full !== undefined) {
            return item.score.total.full;
          }
          if (item.score.full !== undefined) {
            return item.score.full;
          }
          return 0;
        },

        /**
         * 获取题型显示名称（针对特定题型进行名称替换）
         * @param {Object} item - 题目结果项
         * @returns {String} 显示名称
         */
        getTopicTypeDisplayName(item) {
          if (!item || !item.topictype) {
            return '';
          }
          // FIB_R (题型ID 11) 改为 FIB_Drag&Drop
          if (item.topic_type_id === 11) {
            return 'FIB_Drag&Drop';
          }
          // FIB_RW (题型ID 12) 改为 FIB_Dropdown
          if (item.topic_type_id === 12) {
            return 'FIB_Dropdown';
          }
          return item.topictype.short_name || '';
        },

        /**
         * 获取传递过来的参数
         * @description 解析URL参数，判断是否为分享模式
         */
        getParams() {
          _this.user_exam_id = _this.$route.query.user_exam_id;
          // 判断是否为分享查看模式
          _this.isShareView = _this.$route.query.share === '1';
          _this.getScore();
        },
        /**
         * 获取模考结果
         * @description 根据是否为分享模式调用不同接口
         */
        getScore(isPolling = false) {
          var params = {
              user_exam_id: _this.user_exam_id,
          };
          // 根据是否为分享模式选择不同的接口
          const apiUrl = _this.isShareView ? "exam.user_exam/shareScore" : "exam.user_exam/score";
          _this.$axios
            .post(apiUrl, params)
            .then((res) => {
            console.log(res);
            if (res.code == 1) {
                if (!_this.isShareView && !_this.hasCompleteScoreResult(res)) {
                  _this.pageLoading = false;
                  _this.scorePending = true;
                  _this.resetScoreData();
                  if (!isPolling) {
                    _this.$message.warning('分数计算中，请稍后');
                  }
                  _this.startScorePolling();
                  return;
                }
                _this.pageLoading = false;
                _this.scorePending = false;
                _this.stopScorePolling();
                _this.scores = [
                  res.data.listening,
                  res.data.reading,
                  res.data.speaking,
                  res.data.writing
                ];
                _this.topic_percent = res.data.topic_percent
                _this.topic_type_list = res.data.topic_percent[0].topic_type_list
                _this.topic_list1 = _this.fixMcmScoreInTopicList(res.data.topic_percent[0].topic_list)
                _this.topic_list2 = _this.fixMcmScoreInTopicList(res.data.topic_percent[1].topic_list)
                _this.topic_list3 = _this.fixMcmScoreInTopicList(res.data.topic_percent[2].topic_list)
                _this.topic_list4 = _this.fixMcmScoreInTopicList(res.data.topic_percent[3].topic_list)
                // 设置用户信息和试卷信息
                _this.userInfo = res.data.user_info;
                _this.examTitle = res.data.exam_title || '模考试卷';
                _this.examCreatetime = res.data.createtime || '';
            } else {
                _this.pageLoading = false;
                if (!_this.isShareView && res.msg && res.msg.indexOf('计算') !== -1) {
                  _this.scorePending = true;
                  if (!isPolling) {
                    _this.$message.warning('分数计算中，请稍后');
                  }
                  _this.startScorePolling();
                } else {
                  _this.$message.error(res.msg);
                }
            }
            })
            .catch((err) => {
            console.log(err);
            if (!_this.isShareView && err && err.msg && (err.msg.indexOf('计算') !== -1 || err.msg.indexOf('稍后') !== -1)) {
              _this.pageLoading = false;
              _this.scorePending = true;
              if (!isPolling) {
                _this.$message.warning('分数计算中，请稍后');
              }
              _this.startScorePolling();
              return;
            }
            _this.pageLoading = false;
            _this.stopScorePolling();
            });
        },
        handleClick(tab, event) {
          if(tab._data.index > 0) {
            _this.topic_type_list = _this.topic_percent[tab._data.index-1].topic_type_list
          }
          console.log(tab, event);
        },
        handleClick2(tab, event) {
          console.log(tab, event);
        },
        // 跳转题目页面
        toTopic(e){
          let path = '/questionType1';
          let href = '';
          if (e.topic_type_id == 20 || e.topic_type_id == 21) {
            // 听写句子
            href = "/questionType14?id="+e.topic.id+"&name="+e.topictype.name
          } else if (e.topic_type_id == 1) {
            // 朗读句子
            href = "/questionType1?id="+e.topic.id+"&name="+e.topictype.name
          } else if (e.topic_type_id == 6) {
            // 短文写作
            href = "/questionType6?id="+e.topic.id+"&name="+e.topictype.name
          } else if (e.topic_type_id == 7) {
            // 总结全文
            href = "/questionType6?id="+e.topic.id+"&name="+e.topictype.name
          } else if (e.topic_type_id == 8) {
            // 阅读单选
            href = "/questionType4?id="+e.topic.id+"&name="+e.topictype.name
          } else if (e.topic_type_id == 9) {
            // 阅读多选
            href = "/questionType7?id="+e.topic.id+"&name="+e.topictype.name
          } else if (e.topic_type_id == 17) {
            // 听力单选
            href = "/questionType8?id="+e.topic.id+"&name="+e.topictype.name
          } else if (e.topic_type_id == 3) {
            // 描述图片
            href = "/questionType3?id="+e.topic.id+"&name="+e.topictype.name
          } else if (e.topic_type_id == 2) {
            // 描述图片
            href = "/questionType9?id="+e.topic.id+"&name="+e.topictype.name
          } else if (e.topic_type_id == 4 || e.topic_type_id == 27) {
            // 描述图片
            href = "/questionType9?id="+e.topic.id+"&name="+e.topictype.name
          } else if (e.topic_type_id == 5) {
            // 短回答
            href = "/questionType9?id="+e.topic.id+"&name="+e.topictype.name
          } else if (e.topic_type_id == 10) {
            // 段落排序
            href = "/questionType10?id="+e.topic.id+"&name="+e.topictype.name
          } else if (e.topic_type_id == 11) {
            // 阅读拖拽完型填空
            href = "/questionType11?id="+e.topic.id+"&name="+e.topictype.name
          } else if (e.topic_type_id == 12) {
            // 阅读下拉完型填空
            href = "/questionType12?id="+e.topic.id+"&name="+e.topictype.name
          } else if (e.topic_type_id == 16) {
            // 摘要选择
            href = "/questionType8?id="+e.topic.id+"&name="+e.topictype.name
          } else if (e.topic_type_id == 18) {
            // 补全对话
            href = "/questionType8?id="+e.topic.id+"&name="+e.topictype.name
          } else if (e.topic_type_id == 13) {
            // 录音总结
            href = "/questionType14?id="+e.topic.id+"&name="+e.topictype.name
          } else if (e.topic_type_id == 15) {
            // 听力填空
            href = "/questionType15?id="+e.topic.id+"&name="+e.topictype.name
          } else if (e.topic_type_id == 19) {
            // 识别错词
            href = "/questionType16?id="+e.topic.id+"&name="+e.topictype.name
          } else if (e.topic_type_id == 14) {
            // 听力多选
            href = "/questionType17?id="+e.topic.id+"&name="+e.topictype.name
          } else if (e.topic_type_id == 22||e.topic_type_id == 26) {
            // 情景描述
            href = "/questionType9?id="+e.topic.id+"&name="+e.topictype.name
          } else if (e.topic_type_id == 23) {
            // 大作文（CORE）
            href = "/questionType6?id="+e.topic.id+"&name="+e.topictype.name
          } else if (e.topic_type_id == 24) {
            // 总结全文（CORE）
            href = "/questionType6?id="+e.topic.id+"&name="+e.topictype.name
          } else if (e.topic_type_id == 25) {
            // 录音总结（CORE）
            href = "/questionType14?id="+e.topic.id+"&name="+e.topictype.name
          }
          window.open(href,'_blank')
        },
        /**
         * 将文本拆分为单词数组
         * @description 用于将文本内容拆分为可点击的单词
         * @param {String} text - 要拆分的文本
         * @returns {Array} 单词数组
         */
        splitTextToWords(text) {
          if (!text) return [];
          // 去除HTML标签，保留纯文本
          const plainText = text.replace(/<[^>]+>/g, ' ');
          // 按空格拆分，过滤空字符串
          return plainText.split(/\s+/).filter(word => word.trim());
        },
        // 点击事件
        dianjiClick(item) {
          const word = this.getShowTextWord(item);
          if(!word || word == '&nbsp;' || this.isShowTextBreak(item) || !this.isSelectableShowTextItem(item)) {return;}
          // 清理单词中的标点符号用于查词
          const cleanWord = word.replace(/[.,!?;:'"()]/g, '').trim();
          if(!cleanWord) {return;}
          this.$refs.word.word_text = cleanWord;
          this.$refs.word.getWord();
        },
        // 查看评分
        view_result(e){
          console.log('eee',e);
          let obj = e.score
          if(obj) {
            obj.topic_type_id = e.topic_type_id
            console.log('objobjobj',obj);
            let kouyu_arr = _this.speaking_arr;
            obj.qiniu_url = "";
            console.log(kouyu_arr.includes(e.topic_type_id));
            if(kouyu_arr.includes(e.topic_type_id)) {
              obj.qiniu_url = "https://static.yijishen.com"
              obj.content = e.content
            }
            if(e.topic_type_id == 11 || e.topic_type_id == 12 || e.topic_type_id == 15) {
              obj.fib_correct_answers = _this.getFibCorrectAnswersFromTopic(e.topic, e.topic_type_id)
            }
            if(e.topic_type_id == 19) {
              console.log('eeeeeee',e,obj);
              // 保存 score.content 数组（用于评分计算）
              obj.content_arr = obj.content || []
              obj.return_obj = obj.return || {}
              // 覆盖 content 为用户作答的原始内容（用于显示）
              obj.content = e.content
              obj.daan = e.topic.extend.daan
            }
            if(e.topic_type_id == 10) {
              obj.content = e.content || obj.content
              obj.daan = e.topic.extend.daan
              obj.extend_sort = e.topic.extend.extend_sort || []
            }
            // SST、SWT、WE 写作类题型需要传递作答内容
            if(e.topic_type_id == 6 || e.topic_type_id == 7 || e.topic_type_id == 13) {
              obj.content = e.content
            }
          } else {
            obj = {
              topic_type_id: e.topic_type_id,
              content: e.content
            }
          }
          this.$refs.result.obj = obj;
          this.$refs.result.status = true;
        },
        // 查看翻译
        view_translate(e){
          let content = e.topic.exam_translate
          if(e.topic_type_id == 11 || e.topic_type_id == 12) {
            content = e.topic.extend.fanyi
          }
          this.$refs.translate.content = content;
          this.$refs.translate.status = true;
        },
        // 返回上一页
        goBack() {
          _this.$router.go(-2);
        },
        // 获取HIW题型的正确答案
        getHIWCorrectAnswer(item, currentIndex) {
          if (!item.topic.extend.daan) {
            return '';
          }

          // 获取所有错误单词的索引位置
          const errorIndices = [];
          item.topic.extend.HIW.forEach((hiwItem, idx) => {
            if (hiwItem.index == 1) {
              errorIndices.push(idx);
            }
          });

          // 获取当前错误单词在所有错误单词中的位置
          const errorIndex = errorIndices.indexOf(currentIndex);

          if (errorIndex === -1) {
            return '';
          }

          // 处理正确答案
          let correctAnswers = [];
          if (Array.isArray(item.topic.extend.daan)) {
            correctAnswers = item.topic.extend.daan;
          } else if (typeof item.topic.extend.daan === 'string') {
            // 尝试用逗号、分号或空格分隔
            correctAnswers = item.topic.extend.daan.split(/[,，;；\s]+/).filter(item => item.trim());
          }

          // 返回对应的正确答案，如果只有一个答案则返回该答案，否则按索引返回
          if (correctAnswers.length === 1) {
            return correctAnswers[0].trim();
          } else if (correctAnswers.length > errorIndex) {
            return correctAnswers[errorIndex].trim();
          }

          return item.topic.extend.daan;
        },
        // HIW点击正确答案查单词
        dianjiClick2(item, currentIndex) {
          if (!item.topic.extend.daan) {
            return '';
          }

          // 获取所有错误单词的索引位置
          const errorIndices = [];
          item.topic.extend.HIW.forEach((hiwItem, idx) => {
            if (hiwItem.index == 1) {
              errorIndices.push(idx);
            }
          });

          // 获取当前错误单词在所有错误单词中的位置
          const errorIndex = errorIndices.indexOf(currentIndex);

          if (errorIndex === -1) {
            return '';
          }

          // 处理正确答案
          let correctAnswers = [];
          if (Array.isArray(item.topic.extend.daan)) {
            correctAnswers = item.topic.extend.daan;
          } else if (typeof item.topic.extend.daan === 'string') {
            // 尝试用逗号、分号或空格分隔
            correctAnswers = item.topic.extend.daan.split(/[,，;；\s]+/).filter(item => item.trim());
          }

          // 返回对应的正确答案，如果只有一个答案则返回该答案，否则按索引返回
          if (correctAnswers.length === 1) {
            this.$refs.word.word_text = correctAnswers[0].trim();
            this.$refs.word.getWord();
            return;
          } else if (correctAnswers.length > errorIndex) {
            this.$refs.word.word_text = correctAnswers[errorIndex].trim();
            this.$refs.word.getWord();
            return;
          }
          this.$refs.word.word_text = item.topic.extend.daan;
          this.$refs.word.getWord();

          return;
        },
        /**
         * 分享题目功能
         * @description 分享单个题目到剪贴板
         * @param {Object} item - 题目信息
         */
        shareTopic(item) {
          // 构建分享文案
          let shareText = `${item.topictype.short_name}第${item.topic.number}题`;
          if (item.score && item.score.total) {
            shareText += `，得分：${item.score.total.score}/${item.score.total.full}`;
          } else if (item.score && item.score.score !== undefined) {
            shareText += `，得分：${item.score.score}/${item.score.full}`;
          }
          shareText += `，点击查看详情：`;

          // 构建分享链接，参考H5Detail.vue的URL格式
          // 注意：H5Detail使用的参数名是exericise_id（拼写如此）
          const baseUrl = window.location.origin;
          const shareUrl = `${baseUrl}/H5Detail?exericise_id=${item.id}&topic_id=${item.topic.id}&pinyin=${item.topictype.short_name}&title=${encodeURIComponent(item.topictype.short_name)}`;

          // 复制到剪贴板
          const fullText = shareText + shareUrl;
          this.$copyText(fullText).then(
            () => {
              this.$message.success("分享链接已复制到剪贴板");
            },
            () => {
              this.$message.error("复制失败，请手动复制");
            }
          );
        },
        /**
         * 分享试卷功能
         * @description 分享整个模考试卷结果，未登录用户也可查看
         */
        shareExam() {
          // 计算总分
          const totalScore = (this.scores[0] + this.scores[1] + this.scores[2] + this.scores[3]).toFixed(2);
          const average = (totalScore / 4).toFixed(2);

          // 构建分享文案
          let shareText = `【${this.examTitle}】模考成绩单\n`;
          shareText += `答题人：${this.userInfo?.nickname || this.userInfo?.username || '匿名用户'}\n`;
          shareText += `听力：${this.scores[0]}分 | 阅读：${this.scores[1]}分 | 口语：${this.scores[2]}分 | 写作：${this.scores[3]}分\n`;
          shareText += `总分：${average}分\n`;
          shareText += `点击查看详情：`;

          // 构建分享链接（带share=1参数，表示分享模式）
          const baseUrl = window.location.origin;
          const shareUrl = `${baseUrl}/mokaoScore?user_exam_id=${this.user_exam_id}&share=1`;

          // 复制到剪贴板
          const fullText = shareText + shareUrl;
          this.$copyText(fullText).then(
            () => {
              this.$message.success("试卷分享链接已复制到剪贴板，未登录用户也可查看");
            },
            () => {
              this.$message.error("复制失败，请手动复制");
            }
          );
        },
    },
  };
  </script>


<style scoped>
.container {
  font-family: "PingFang SC", "Hiragino Sans GB", "Segoe UI", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif, "Chinese Quote", -apple-system, BlinkMacSystemFont;
}
.vue-echarts-example {
  width: 90%;
  height: 400px;
  padding-top: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.score_report_card {
  margin-bottom: 20px;
  padding: 24px 28px;
  border: 1px solid #e6eaef;
  border-radius: 12px;
  background: #ffffff;
}
.score_report_summary_panel {
  margin-bottom: 20px;
  padding: 24px 28px;
  border: 1px solid #e6eaef;
  border-radius: 12px;
  background: #ffffff;
}
.score_report_summary_intro {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 16px;
  margin-bottom: 20px;
}
.score_report_score_grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 16px;
}
.score_report_score_item {
  min-height: 148px;
  padding: 18px 12px;
  border-radius: 12px;
  background: #f8fafc;
  border: 1px solid #edf2f7;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.score_report_score_item_total {
  background: #fff7f3;
  border-color: #fde6dc;
}
.score_report_score_label {
  margin-top: 14px;
  font-size: 14px;
  font-weight: 500;
  color: #475467;
  text-align: center;
}
.score_report_score_circle {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  font-size: 22px;
  font-weight: 600;
  border: 4px solid transparent;
}
.score_circle_total {
  color: #f6704b;
  border-color: #f6704b;
}
.score_circle_listening {
  color: #112F52;
  border-color: #112F52;
}
.score_circle_reading {
  color: #CDC950;
  border-color: #CDC950;
}
.score_circle_speaking {
  color: #565656;
  border-color: #565656;
}
.score_circle_writing {
  color: #8E277C;
  border-color: #8E277C;
}
.score_circle_default {
  color: #94a3b8;
  border-color: #94a3b8;
}
.score_loading_state {
  margin-bottom: 20px;
  padding: 72px 24px;
  border: 1px solid #e6eaef;
  border-radius: 12px;
  background: #ffffff;
  text-align: center;
}
.score_loading_spinner {
  font-size: 28px;
  color: #f6704b;
}
.score_loading_title {
  margin-top: 18px;
  font-size: 20px;
  font-weight: 600;
  color: #101828;
}
.score_loading_text {
  margin-top: 8px;
  font-size: 14px;
  color: #667085;
}
.score_pending_notice {
  margin-bottom: 20px;
  padding: 16px 20px;
  border-radius: 12px;
  border: 1px solid #fde6dc;
  background: #fff7f3;
}
.score_pending_title {
  font-size: 15px;
  font-weight: 600;
  color: #c2410c;
}
.score_pending_text {
  margin-top: 6px;
  font-size: 13px;
  color: #9a3412;
}
.score_report_header {
  margin-bottom: 18px;
}
.score_report_heading {
  font-size: 22px;
  font-weight: 600;
  color: #101828;
}
.score_report_caption {
  margin-top: 4px;
  font-size: 14px;
  color: #667085;
}
.communicative_skills_card {
  padding: 20px 22px 18px;
  border-radius: 12px;
  background: #fbfcfe;
  border: 1px solid #edf1f5;
}
.communicative_skills_scale_row {
  display: grid;
  grid-template-columns: 110px 1fr;
  gap: 16px;
}
.communicative_skills_scale {
  position: relative;
  height: 18px;
  margin-bottom: 10px;
  font-size: 11px;
  color: #98a2b3;
}
.communicative_skills_tick {
  position: absolute;
  top: 0;
  transform: translateX(-50%);
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1;
}
.communicative_skills_tick_label {
  line-height: 18px;
}
.communicative_skills_tick_mark {
  width: 1px;
  height: 8px;
  margin-top: 2px;
  background: #d0d5dd;
}
.communicative_skills_tick:first-child {
  transform: translateX(0);
  align-items: flex-start;
}
.communicative_skills_tick:last-child {
  transform: translateX(-100%);
  align-items: flex-end;
}
.communicative_skills_body {
  position: relative;
}
.communicative_track_overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 126px;
  right: 0;
  pointer-events: none;
}
.communicative_total_line {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 0;
  border-left: 2px dashed #101828;
  z-index: 2;
}
.communicative_total_badge {
  position: absolute;
  top: -6px;
  left: 0;
  transform: translate(-50%, -100%);
  padding: 4px 8px;
  border-radius: 999px;
  background: #101828;
  color: #ffffff;
  font-size: 12px;
  white-space: nowrap;
}
.communicative_skill_row {
  display: grid;
  grid-template-columns: 110px 1fr;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
}
.communicative_skill_row:last-child {
  margin-bottom: 0;
}
.communicative_skill_label {
  font-size: 14px;
  font-weight: 500;
  color: #344054;
}
.communicative_skill_track {
  position: relative;
  height: 18px;
  border-radius: 999px;
  background: linear-gradient(90deg, #eef2f6 0%, #f7f9fc 100%);
  overflow: visible;
}
.communicative_skill_fill {
  height: 100%;
  border-radius: 999px;
  background: #f6704b;
}
.communicative_skill_value {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  font-size: 12px;
  font-weight: 600;
  color: #101828;
}
.score_report_summary {
  padding: 8px 0;
}
.score_report_summary_title {
  font-size: 16px;
  font-weight: 600;
  color: #101828;
}
.score_report_summary_text {
  margin-top: 8px;
  font-size: 14px;
  line-height: 1.6;
  color: #667085;
}
.btn_view {
  border: 1px solid #f6704b;color: #f6704b;font-size: 12px;border-radius: 20px;padding: 2px 6px;margin-right: 10px;cursor: pointer;
}
.common_title {
  margin-top: 24px;
  font-size: 16px;
  font-weight: 500;
  color: #666;
  margin-bottom: 10px;
}
.common_title2 {
  margin-top: 24px;
  font-size: 16px;
  color: #333;
  margin-bottom: 10px;
}
.topic_type_name{
  font-size: 14px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 16px;
}
.topic_actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  white-space: nowrap;
}
.to_topic_detail{
  font-size: 14px;
  color: #3F7CE1;
  cursor: pointer;
  white-space: nowrap;
}
.share_button {
  font-size: 14px;
  color: #3F7CE1;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.3s;
  white-space: nowrap;
}
.share_button:hover {
  background-color: rgba(63, 124, 225, 0.1);
}
.topic_answer {
  margin-top: 24px;
  background-color: #f5f6f7;
  padding: 16px;
  color:#333;
  font-size: 16px !important;
  line-height: 1.5 !important;
}
.ro_choose {
  font-size: 16px;
  line-height: 1.5;
  cursor: pointer;
}
.fib_choose {
  margin-top: 24px;
  margin-bottom: 10px;
  font-size: 16px;
  line-height: 1.5;
}
.my_padding {
  box-shadow: none;
  font-size: 16px;
}
.topic_type_name_asq {
  font-size: 16px;
  color: #000;
}
.topic_type_timu_box,.topic_type_timu_box p {
  color: #333 !important;
}
/* 可点击单词样式 */
.clickable_word {
  cursor: pointer;
  transition: color 0.2s, background-color 0.2s;
  border-radius: 2px;
  padding: 0 2px;
}
.clickable_word:hover {
  color: #f6704b;
  background-color: rgba(246, 112, 75, 0.1);
}
.topic_answer {
  font-size: 16px !important;
  color: #333 !important;
}
/* 用户信息卡片样式 */
.user_info_card {
  background-color: #ffffff;
  padding: 20px 30px;
  border-radius: 10px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}
.user_info_left {
  display: flex;
  align-items: center;
}
.user_avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 16px;
  border: 2px solid #f6704b;
}
.user_detail {
  display: flex;
  flex-direction: column;
}
.user_name {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}
.exam_info {
  display: flex;
  align-items: center;
  gap: 20px;
}
.exam_title {
  font-size: 14px;
  color: #f6704b;
  background-color: rgba(246, 112, 75, 0.1);
  padding: 4px 12px;
  border-radius: 4px;
}
.exam_time {
  font-size: 14px;
  color: #999;
}
.user_info_right {
  display: flex;
  align-items: center;
}
.skills_profile_card {
  margin-bottom: 20px;
  padding: 20px 24px;
  border: 1px solid #e6eaef;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);
}
.skills_profile_header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 14px;
  padding-bottom: 12px;
  border-bottom: 1px solid #edf1f5;
}
.skills_profile_eyebrow {
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #65758b;
}
.skills_profile_heading {
  font-size: 24px;
  line-height: 1.1;
  font-weight: 600;
  color: #0f172a;
}
.skills_profile_caption {
  margin-top: 2px;
  font-size: 13px;
  color: #667085;
}
.skills_profile_list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 28px;
  row-gap: 0;
}
.skills_profile_item {
  padding: 10px 0;
  border-bottom: 1px solid #edf1f5;
  background-color: #ffffff;
}
.skills_profile_item:nth-last-child(-n + 2) {
  padding-bottom: 0;
  border-bottom: 0;
}
.skills_profile_item_top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-bottom: 6px;
}
.skills_profile_meta {
  flex: 1;
}
.skills_profile_title_row {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 10px;
}
.skills_profile_name {
  font-size: 15px;
  font-weight: 600;
  color: #101828;
}
.skills_profile_name_cn {
  font-size: 13px;
  color: #667085;
  font-weight: 500;
}
.skills_profile_alias {
  margin-top: 2px;
  font-size: 12px;
  color: #98a2b3;
  line-height: 1.35;
}
.skills_profile_bar {
  position: relative;
  height: 6px;
  overflow: hidden;
  border-radius: 999px;
  background-color: #e9eef5;
}
.skills_profile_bar_fill {
  height: 100%;
  border-radius: 999px;
  background: #f6704b;
}
.skills_profile_bar_marker {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  width: 1px;
  background: rgba(255, 255, 255, 0.9);
}
@media (max-width: 768px) {
  .score_report_summary_intro {
    display: block;
  }
  .score_report_score_grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .score_report_score_item_total {
    grid-column: 1 / -1;
  }
  .skills_profile_card {
    padding: 16px 14px;
  }
  .skills_profile_list {
    grid-template-columns: 1fr;
  }
  .skills_profile_item:nth-last-child(-n + 2) {
    border-bottom: 1px solid #edf1f5;
  }
  .skills_profile_item:last-child {
    border-bottom: 0;
    padding-bottom: 0;
  }
  .skills_profile_header {
    flex-direction: column;
    align-items: flex-start;
  }
  .skills_profile_heading {
    font-size: 20px;
  }
  .skills_profile_item_top {
    flex-direction: column;
    align-items: flex-start;
  }
}
  </style>
